import React from 'react';

// Horizontal rule with an optional centered label chip.
// Background color (#f8faf9) matches the page canvas so the chip floats cleanly.

interface SectionDividerProps {
  /** When omitted renders a plain <hr>. */
  label?: string;
  className?: string;
}

export const SectionDivider: React.FC<SectionDividerProps> = ({
  label,
  className = '',
}) => {
  if (!label) {
    return <hr className={`border-border ${className}`} />;
  }

  return (
    <div
      className={`relative flex items-center py-2 ${className}`}
      role="separator"
      aria-label={label}
    >
      <div className="flex-grow border-t border-border" aria-hidden="true" />
      <span className="mx-4 shrink-0 px-3 py-1 rounded-full bg-[#f8faf9] border border-border text-xs font-semibold text-text-secondary uppercase tracking-wider">
        {label}
      </span>
      <div className="flex-grow border-t border-border" aria-hidden="true" />
    </div>
  );
};
